import { Tag } from 'primereact/tag';
import React from 'react';
import { SelectedRow } from '../salaries-generator-page';

export interface SalariesToolBarDatamodel {
  selectedRows: SelectedRow[];
}

export const SalariesToolBar: React.FC<SalariesToolBarDatamodel> = ({
  selectedRows,
}) => {
  return (
    <div
      style={{
        marginTop: '16px',
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '20px',
        backgroundColor: '#fafafa',
        borderRadius: '12px',
        boxShadow: '0 4px 6px rgba(0,0,0,0.05)',
        border: '1px solid #e5e7eb',
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <h1
          style={{
            margin: 0,
            fontSize: '28px',
            fontWeight: '600',
            color: '#6b21a8',
            letterSpacing: '-0.025em',
          }}
        >
          ניהול משכורות
        </h1>
        <p
          style={{
            margin: 0,
            fontSize: '16px',
            color: '#7e22ce',
            fontWeight: '500',
          }}
        >
          בחר את הפעילויות שברצונך לשלם עבורן
        </p>
      </div>
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          backgroundColor: '#f3e8ff',
          padding: '12px 16px',
          borderRadius: '8px',
          border: '1px solid #e9d5ff',
        }}
      >
        <Tag
          value={`${selectedRows.length} דיווחים נבחרו`}
          severity="info"
          style={{
            fontSize: '14px',
            backgroundColor: '#7e22ce',
            color: 'white',
            padding: '8px 12px',
            borderRadius: '6px',
          }}
        />
        <Tag
          value={`₪${selectedRows.reduce((sum, row) => sum + row.total, 0)}`}
          severity="success"
          style={{
            fontSize: '14px',
            backgroundColor: '#10b981',
            color: 'white',
            padding: '8px 12px',
            borderRadius: '6px',
          }}
        />
      </div>
    </div>
  );
};
